import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { FooterSelectMenuTypeEnum } from 'enums/entity';
import { AgentPermissionsEnum } from 'enums/accessTemplates';

import { translate } from 'utils/translate';
import useAuth from 'store/auth';
import usePartners from 'store/partner';
import { AccessChangePartnerPermissions } from 'utils/accessTemplates';

import { ProfileDrawerSelectedListType } from './types';

type Props = {
  onClose: () => void;
  onChangePassword: () => void;
  setOpenSelectList: (type: ProfileDrawerSelectedListType) => void;
  permissions?: AgentPermissionsEnum[];
};

const ProfileDrawerMainMenu: FC<Props> = ({ onClose, onChangePassword, setOpenSelectList, permissions }) => {
  const navigate = useNavigate();
  const [authState, authAction] = useAuth();
  const [partners] = usePartners();
  const selected = authState?.data?.agent?.activePartnerId || authState?.data?.agent?.partner?.id;
  const selectedName = partners.data.find((item) => item.id === selected)?.name;

  const handleChangePassword = (): void => {
    onClose();
    onChangePassword();
  };

  const handleLogout = (): void => {
    authAction.logout();
  };

  const handleProfile = (): void => {
    navigate(`/agents/${authState?.data?.agent?.id}/dashboard`);
    onClose();
  };

  const handleWebsiteClick = (): void => {
    setOpenSelectList(FooterSelectMenuTypeEnum.PARTNER);
  };

  return (
    <List>
      {AccessChangePartnerPermissions.some((r) => permissions?.includes(r)) && (
        <ListItem>
          <Button
            color="inherit"
            fullWidth
            sx={{ justifyContent: 'space-between', p: 0 }}
            onClick={handleWebsiteClick}
            endIcon={<ArrowForwardIosIcon />}
          >
            <Typography component="span" variant="body1" whiteSpace="nowrap">
              {selectedName}
            </Typography>
          </Button>
        </ListItem>
      )}
      <ListItem disablePadding>
        <ListItemButton onClick={handleProfile}>
          <ListItemText primary={translate('Profile')} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton onClick={handleChangePassword}>
          <ListItemText primary={translate('Change Password')} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton onClick={handleLogout}>
          <ListItemText primary={translate('Logout')} sx={{ color: 'custom.red.scale.500' }} />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default ProfileDrawerMainMenu;
